import { ITokenStorage } from '../interfaces/token-storage.interface';

export class LogoutUserUseCase {
  constructor(private readonly tokenStorage: ITokenStorage) {}

  public execute(): void {
    this.tokenStorage.clear();
  }
}
